import { render } from "./Porto Marina Alexandria.vue?vue&type=template&id=019a453d&scoped=true"
const script = {}

import "./Porto Marina Alexandria.vue?vue&type=style&index=0&id=019a453d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-019a453d"

export default script